import { ReactNode } from 'react';
import { FormItemProps, FormInstance } from 'antd/lib/form';
import { HelpTooltipProps } from '../../HelpTooltip/helpTooltip';
import { UploadFileProps } from '../../SuperUpload/uploadFile';
import { RouteLinkProps } from '../../RouteLink/interface';

export interface BaseSearchFormItemProps extends Omit<FormItemProps, 'children'> {
  /** 测试ID */
  testId?: string;
  /** form 控制实例 */
  form?: FormInstance;
  /** 栅格占位格数，为 0 时相当于 display: none */
  span?: number;
  /** 栅格左侧的间隔格数，间隔内不可以有栅格 */
  offset?: number;
  /** 栅格顺序 */
  order?: number;
  /** 栅格向左移动格数 */
  pull?: number;
  /** 栅格向右移动格数 */
  push?: number;
  /** 禁用是展示节点 */
  render?: ReactNode | ((val?: any) => ReactNode);
  /** 是否在详情页中展示 */
  isDetail?: boolean;
  /** 禁用时展示字段 */
  disabledRenderKey?: string | ((data?: any) => ReactNode);
  /** 禁用时展示文字 */
  disabledRender?: ReactNode | ((data?: any) => ReactNode);
  /** 提示语配置 */
  helpTooltipProps?: HelpTooltipProps | string;
  /** 单位 */
  company?: ReactNode;
  /** 单位宽度 */
  companyWidth?: number;
  /** 是否在表格中展示 */
  isTable?: boolean;
  /** 是否隐藏标题 */
  hideLabel?: boolean;
  /** 图片相对路径字段 */
  relativePathName?: string;
  /** 是否可复制 */
  copy?: boolean;
  /** 表单头部标题 */
  topTitle?: ReactNode;
  /** 头部标题类名 */
  topTitleClassName?: string;
  /** 关联表单字段名称 只有表单类型为 Select SelectTab SelectGroup Cascader SuperSelect SuperSelectTable 有效 */
  associationName?: string;
  /** 关联表单字段名称集合 只有cardForm内的表单有该属性生效 */
  associationNames?: string[];
  /** 禁用文字链接配置 */
  routeLinkProps?: RouteLinkProps;
  uploadProps?: UploadFileProps;
  hide?: boolean | ((data: any) => boolean);
  /** 改组值改变后修改表单配置方法，只有cardForm内的表单有该属性生效 */
  changeFormatProps?: (data: any) => any;
  children?: any;
}

export type filterSpaceType = 'left' | 'right' | 'both' | 'all' | false;

export enum SearchFormItemEnum {
  SearchFormGroup = 'SearchFormGroup',
  SearchFormInput = 'SearchFormInput',
  SearchFormButton = 'SearchFormButton',
  SearchFormSwitch = 'SearchFormSwitch',
  SearchFormInputNumber = 'SearchFormInputNumber',
  SearchFormSelect = 'SearchFormSelect',
  SearchFormSuperSelect = 'SearchFormSelect',
  SearchFormSelectTab = 'SearchFormSelectTab',
  SearchFormSelectInput = 'SearchFormSelectInput',
  SearchFormSelectTable = 'SearchFormSelectTable',
  SearchFormSuperSelectTable = 'SearchFormSuperSelectTable',
  SearchFormOperation = 'SearchFormOperation',
  SearchFormTabs = 'SearchFormTabs',
  SearchFormOther = 'SearchFormOther',
  SearchFormUpload = 'SearchFormUpload',
  SearchFormUploadImage = 'SearchFormUploadImage',
  SearchFormUploadImages = 'SearchFormUploadImages',
  SearchFormTextArea = 'SearchFormTextArea',
  SearchFormDatePicker = 'SearchFormDatePicker',
  SearchFormRangePicker = 'SearchFormRangePicker',
  SearchFormTimePicker = 'SearchFormTimePicker',
  SearchFormCustomItem = 'SearchFormCustomItem',
  SearchFormFixed = 'SearchFormFixed',
  SearchFormInputSelect = 'SearchFormInputSelect',
  SearchFormInputInterval = 'SearchFormInputInterval',
  SearchFormCheckboxGroup = 'SearchFormCheckboxGroup',
  SearchFormCheckbox = 'SearchFormCheckbox',
  SearchFormCombination = 'SearchFormCombination',
  SearchFormTreeSelect = 'SearchFormTreeSelect',
  SearchFormAssociateSelect = 'SearchFormAssociateSelect',
  SearchFormAutoMatch = 'SearchFormAutoMatch',
  SearchFormAddress = 'SearchFormAddress',
  SearchFormRadioGroup = 'SearchFormRadioGroup',
  SearchFormSelectGroup = 'SearchFormSelectGroup',
  SearchFormTextAreaRow = 'SearchFormTextAreaRow',
  SearchFormTimeSlot = 'SearchFormTimeSlot',
  SearchFormSelectCustom = 'SearchFormSelectCustom',
  SearchFormZoneTime = 'SearchFormZoneTime',
  SearchFormSelectGroupTable = 'SearchFormSelectGroupTable',
  SearchFormCascader = 'SearchFormCascader',
  SearchFormScanInput = 'SearchFormScanInput',
  SearchFormAutoComplete = 'SearchFormAutoComplete',
  SearchFormLine = 'SearchFormLine',
  SearchFormUploadAvatar = 'SearchFormUploadAvatar',
  SearchFormGroupSearch = 'SearchFormGroupSearch',
  SearchFormRows = 'SearchFormRows',
  SearchFormIntervalType = 'SearchFormIntervalType',
  SearchFormNumberInterval = 'SearchFormNumberInterval',
  SearchFormDropdownTable = 'SearchFormDropdownTable',
  SearchFormDropdownSyncTable = 'SearchFormDropdownSyncTable',
  SearchFormCardForm = 'SearchFormCardForm',
  SearchFormFieldGroupSearch = 'SearchFormFieldGroupSearch',
  SearchFormSuperTransfer = 'SearchFormSuperTransfer',
  SearchFormDateRange = 'SearchFormDateRange',
  SearchFormSuperAutoComplete = 'SearchFormSuperAutoComplete',
}
